import React from "react";
import { asArray, asText, fitChip } from "../briefModel";
import "../../_shared/QokrPrimitives/_qokr-pill.scss";
import "./_brief-objective-card.scss";

// One company objective in the brief (handoff 34 §4 ③): its `chain` entry
// (fit, winning move › WIGs › annual OKR) joined with its `objectives` entry
// (summary, people, flags, the question for the live review). Either half
// may be missing; every part hides when empty. No Accept / To discuss here —
// the brief only flags and asks (D112).
const Meta = ({ label, children }) =>
  children ? (
    <div className="qokr-brief-obj__meta">
      <span className="qokr-brief-obj__meta-label">{label}</span>
      <span className="qokr-brief-obj__meta-value">{children}</span>
    </div>
  ) : null;

const BriefObjectiveCard = ({ card, onGoTo }) => {
  const { chain, detail } = card;
  const fit = fitChip(chain?.fit);
  const trail = [
    asText(chain?.winning_move),
    asArray(chain?.wigs).map(asText).filter(Boolean).join(", "),
    asText(chain?.annual_okr),
  ].filter(Boolean);
  const contributors = asArray(detail?.contributors)
    .map(asText)
    .filter(Boolean)
    .join(", ");
  const flags = asArray(detail?.flags).map(asText).filter(Boolean);
  const question = asText(detail?.question_for_live_review);

  return (
    <article className="qokr-brief-obj">
      <header className="qokr-brief-obj__head">
        <h4 className="qokr-brief-obj__title">{card.title}</h4>
        {fit ? (
          <span className={`qokr-pill qokr-pill--${fit.tone}`}>
            {fit.label}
          </span>
        ) : null}
      </header>

      {trail.length ? (
        <div className="qokr-brief-obj__trail">
          {trail.map((part, index) => (
            <React.Fragment key={index}>
              {index ? (
                <i
                  className="fa-solid fa-chevron-right qokr-brief-obj__sep"
                  aria-hidden="true"
                />
              ) : null}
              <span>{part}</span>
            </React.Fragment>
          ))}
        </div>
      ) : null}

      {asText(chain?.fit_note) ? (
        <p className="qokr-brief-obj__note">{asText(chain.fit_note)}</p>
      ) : null}

      {asText(detail?.summary) ? (
        <p className="qokr-brief-obj__summary">{asText(detail.summary)}</p>
      ) : null}

      <div className="qokr-brief-obj__metas">
        <Meta label="Owner">{asText(detail?.owner)}</Meta>
        <Meta label="Contributors">{contributors}</Meta>
        <Meta label="Team coverage">{asText(detail?.team_coverage)}</Meta>
        <Meta label="Changed from draft">
          {asText(detail?.changed_from_draft)}
        </Meta>
      </div>

      {flags.length ? (
        <div className="qokr-brief-obj__flags">
          {flags.map((flag, index) => (
            <span className="qokr-brief-obj__flag" key={index}>
              <i
                className="fa-solid fa-triangle-exclamation"
                aria-hidden="true"
              />
              {flag}
            </span>
          ))}
        </div>
      ) : null}

      {question ? (
        <blockquote className="qokr-brief-obj__question">
          <span className="qokr-brief-obj__question-label">
            Ask in the live review
          </span>
          {question}
        </blockquote>
      ) : null}

      {card.inReview && onGoTo ? (
        <div className="qokr-brief-obj__foot">
          <button
            type="button"
            className="qokr-brief-obj__goto"
            onClick={() => onGoTo(card.id)}
          >
            Go to objective
            <i className="fa-solid fa-arrow-right" aria-hidden="true" />
          </button>
        </div>
      ) : null}
    </article>
  );
};

export default BriefObjectiveCard;
